import _asyncToGenerator from "/Users/n8/Development/EtherGrass V2/code/.build/websites/ethergrass.io/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/Users/n8/Development/EtherGrass V2/code/.build/websites/ethergrass.io/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/Users/n8/Development/EtherGrass V2/code/.build/websites/ethergrass.io/node_modules/@babel/runtime/regenerator";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useReducer } from 'react';
import { useEthers, useLocalStorage } from '../../hooks';
import { useBlockNumber } from '../blockNumber/context';
import { useNotificationsContext } from '../notifications/context';
import { TransactionsContext } from './context';
import { DEFAULT_STORED_TRANSACTIONS } from './model';
import { transactionReducer } from './reducer';
export function TransactionProvider(_ref) {
  var children = _ref.children;

  var _useEthers = useEthers(),
      chainId = _useEthers.chainId,
      library = _useEthers.library;

  var blockNumber = useBlockNumber();

  var _useLocalStorage = useLocalStorage('transactions'),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
      storage = _useLocalStorage2[0],
      setStorage = _useLocalStorage2[1];

  var _useReducer = useReducer(transactionReducer, storage !== null && storage !== void 0 ? storage : DEFAULT_STORED_TRANSACTIONS),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      transactions = _useReducer2[0],
      dispatch = _useReducer2[1];

  var _useNotificationsCont = useNotificationsContext(),
      addNotification = _useNotificationsCont.addNotification;

  useEffect(function () {
    setStorage(transactions);
  }, [transactions]);
  var addTransaction = useCallback(function (payload) {
    dispatch({
      type: 'ADD_TRANSACTION',
      payload: payload
    });
    addNotification({
      notification: {
        type: 'transactionStarted',
        transaction: payload.transaction,
        submittedAt: payload.submittedAt,
        transactionName: payload.transactionName
      },
      chainId: payload.transaction.chainId
    });
  }, [dispatch]);
  useEffect(function () {
    var updateTransactions = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _a, checkTransaction, chainTransactions, newTransactions, _iterator, _step, tx, newTransaction;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!chainId || !library || !blockNumber)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                checkTransaction = /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tx) {
                    var receipt, type;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(tx.receipt || !shouldCheck(blockNumber, tx))) {
                              _context.next = 2;
                              break;
                            }

                            return _context.abrupt("return", tx);

                          case 2:
                            _context.prev = 2;
                            _context.next = 5;
                            return library.getTransactionReceipt(tx.transaction.hash);

                          case 5:
                            receipt = _context.sent;

                            if (!receipt) {
                              _context.next = 12;
                              break;
                            }

                            type = receipt.status === 0 ? 'transactionFailed' : 'transactionSucceed';
                            addNotification({
                              notification: {
                                type: type,
                                submittedAt: Date.now(),
                                transaction: tx.transaction,
                                receipt: receipt,
                                transactionName: tx.transactionName
                              },
                              chainId: chainId
                            });
                            return _context.abrupt("return", Object.assign(Object.assign({}, tx), {
                              receipt: receipt
                            }));

                          case 12:
                            return _context.abrupt("return", Object.assign(Object.assign({}, tx), {
                              lastCheckedBlockNumber: blockNumber
                            }));

                          case 13:
                            _context.next = 18;
                            break;

                          case 15:
                            _context.prev = 15;
                            _context.t0 = _context["catch"](2);
                            console.error("failed to check transaction hash: ".concat(tx.transaction.hash), _context.t0);

                          case 18:
                            return _context.abrupt("return", tx);

                          case 19:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[2, 15]]);
                  }));

                  return function checkTransaction(_x) {
                    return _ref3.apply(this, arguments);
                  };
                }();

                chainTransactions = (_a = transactions[chainId]) !== null && _a !== void 0 ? _a : [];
                newTransactions = [];
                _iterator = _createForOfIteratorHelper(chainTransactions);
                _context2.prev = 6;

                _iterator.s();

              case 8:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 16;
                  break;
                }

                tx = _step.value;
                _context2.next = 12;
                return checkTransaction(tx);

              case 12:
                newTransaction = _context2.sent;
                newTransactions.push(newTransaction);

              case 14:
                _context2.next = 8;
                break;

              case 16:
                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](6);

                _iterator.e(_context2.t0);

              case 21:
                _context2.prev = 21;

                _iterator.f();

                return _context2.finish(21);

              case 24:
                dispatch({
                  type: 'UPDATE_TRANSACTIONS',
                  chainId: chainId,
                  transactions: newTransactions
                });

              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[6, 18, 21, 24]]);
      }));

      return function updateTransactions() {
        return _ref2.apply(this, arguments);
      };
    }();

    updateTransactions();
  }, [chainId, library, blockNumber]);
  return _jsx(TransactionsContext.Provider, {
    value: {
      transactions: transactions,
      addTransaction: addTransaction
    },
    children: children
  }, void 0);
}

function shouldCheck(blockNumber, tx) {
  if (tx.receipt) {
    return false;
  }

  if (!tx.lastCheckedBlockNumber) {
    return true;
  }

  var blocksSinceCheck = blockNumber - tx.lastCheckedBlockNumber;

  if (blocksSinceCheck < 1) {
    return false;
  }

  var minutesPending = (Date.now() - tx.submittedAt) / 1000 / 60;

  if (minutesPending > 60) {
    // every 10 blocks if pending for longer than an hour
    return blocksSinceCheck > 9;
  }

  if (minutesPending > 5) {
    // every 3 blocks if pending more than 5 minutes
    return blocksSinceCheck > 2;
  } // otherwise every block


  return true;
}